module.exports = __webpack_public_path__ + "img/default_avatar.8cb3a052.png";